import { createRoot, hydrateRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import { configureStore } from '../shared/store';
import App from '../shared/App';
import IntlProvider from '../shared/i18n/IntlProvider';
import createHistory from '../shared/store/history';

const history = createHistory();

const container = document.getElementById('app');
if (!container) {
    throw new Error('Root element #app not found');
}

const hasSSRMarkup = container.innerHTML.trim().length > 0;

const store =
    window.store ||
    configureStore({
        initialState: window.__PRELOADED_STATE__,
        preferPreloadedOverPersist: hasSSRMarkup,
    });

const appTree = (
    <Provider store={store}>
        <HistoryRouter history={history}>
            <IntlProvider>
                <HelmetProvider>
                    <App />
                </HelmetProvider>
            </IntlProvider>
        </HistoryRouter>
    </Provider>
);

if (hasSSRMarkup) {
    hydrateRoot(container, appTree);
} else {
    createRoot(container).render(appTree);
}

if (import.meta.hot) {
    import.meta.hot.accept();
}

if (process.env.NODE_ENV === 'development' && !window.store) {
    window.store = store;
}
